'use client';

import React from 'react';
import { useLocale } from 'next-intl';

export default function LocalButton() {
  const locale = useLocale();
  const changeLocale = () => {
    const newLocale = locale === 'en' ? 'ar' : 'en';
    window.location.href = `/${newLocale}`;
  };

  return (
    <button
      type="button"
      className="cursor-pointer rounded-4xl border border-[#C1C1C1] px-3.5 py-2 text-sm uppercase hover:bg-[#C1C1C1] hover:text-white"
      onClick={changeLocale}>
      {locale === 'en' ? 'ع' : 'en'}
    </button>
  );
}
